const state = () => ({
    include: [],
})

const getters = {}

const mutations = {
    addAliveItem(state, item) {
        if (!state.include.includes(item)) {
            state.include.push(item)
        }
    },
    removeAliveItem(state, item) {
        state.include = state.include.filter(key => key !== item)
    },
    removeAll(state) {
        state.include = []
    },
}

const actions = {}

export default {
    namespaced: true,
    getters,
    state,
    mutations,
    actions,
}
